import $axios from '@/axios-instance.js'

export const priceListCustomerService = {
  getListData,
  getById,
  create,
  update,
  delete: _delete
}

function getListData (filter, page) {
  return $axios.get(`${process.env.ROOT_API}/price-lists-customer`, { params: Object.assign({ currentPage: page }, filter) }).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/price-lists-customer/${id}`).then(response => {
    return response.data
  })
}

function create (customer) {
  return $axios.post(`${process.env.ROOT_API}/price-lists-customer`, customer).then(response => {
    return response.data
  })
}

function update (customer) {
  return $axios.put(`${process.env.ROOT_API}/price-lists-customer/${customer.customerId}`, customer).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/price-lists-customer/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/price-list-customer.service.js